import { Controller } from "@hotwired/stimulus"

// Connects to the data-controller="bar-position"
export default class extends Controller {
  static targets = ["value"]
  static values = {
    mode: String
  }

  MODE = {
    hide: "hide",
    reposition: "reposition"
  }

  connect() {
    if (this.hasValueTarget) {
      this.updateValuePosition = this.updateValuePosition.bind(this)
      window.addEventListener("resize", this.updateValuePosition)
      this.updateValuePosition()
    }
  }

  disconnect() {
    window.removeEventListener("resize", this.updateValuePosition)
  }

  updateValuePosition() {
    const parent = this.element
    const value = this.valueTarget
    const parentWidth = parent.getBoundingClientRect().width
    const valueWidth = value.getBoundingClientRect().width

    const minWidth = parentWidth - 20
    const shouldReposition = minWidth < valueWidth

    switch (this.modeValue) {
      case this.MODE.hide:
        value.classList.toggle("opacity-0", shouldReposition)
        break
      case this.MODE.reposition:
        value.classList.toggle("absolute", shouldReposition)
        value.classList.toggle("-left-10", shouldReposition)
        value.classList.toggle("top-1/2", shouldReposition)
        value.classList.toggle("-translate-x-full", shouldReposition)
        value.classList.toggle("-translate-y-1/2", shouldReposition)
        value.classList.toggle("text-white", !shouldReposition)
        break
      default:
        console.warn(`Unknown mode: ${this.modeValue}`)
    }
  }
}
